// src/components/layout/AuthLayout.jsx
import React from 'react';
import { Link, Outlet } from 'react-router-dom';

const AuthLayout = () => {
    return (
        <div className="min-h-screen flex flex-col justify-center bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 py-12 px-4 sm:px-6 lg:px-8">
            <div className="absolute top-0 left-0 p-4 md:p-6">
                <Link to="/" className="flex items-center text-white hover:text-indigo-100 transition-colors duration-150">
                    <svg className="h-6 w-6 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                    </svg>
                    <span className="text-sm font-medium">Retour à l'accueil</span>
                </Link>
            </div>

            <Outlet />

            <div className="mt-8 text-center">
                <p className="text-sm text-white opacity-80">
                    &copy; {new Date().getFullYear()} Registre JEE/SIM. Tous droits réservés. Propulsé par : <a
                    href={'https://wwww.yandoama.com'} target={'_blank'} rel={'noreferrer'}>Yandoama Consulting</a>
                </p>
            </div>
        </div>
    );
};

export default AuthLayout;
